(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6115],{

/***/ 3414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ gooddata; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/templates/DividerSection/index.ts
var DividerSection = __webpack_require__(85507);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Modal/useModal.ts
var useModal = __webpack_require__(95290);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/utils/useInView/index.ts + 1 modules
var useInView = __webpack_require__(85807);
// EXTERNAL MODULE: ../../libs/utils/useLottie/useLottie.tsx
var useLottie = __webpack_require__(73849);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../../libs/matcha/components/Modal/index.ts + 2 modules
var Modal = __webpack_require__(33400);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ../../libs/matcha/components/VideoPlayer/index.ts + 2 modules
var VideoPlayer = __webpack_require__(41926);
// EXTERNAL MODULE: ../../libs/utils/usePortal/index.ts
var usePortal = __webpack_require__(47694);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/GoodData/components/VideoModal/VideoModal.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var VideoModal = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var url = _ref.url,
      cover = _ref.cover,
      autoplay = _ref.autoplay;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var modalsRoot = (0,usePortal/* default */.Z)("video-modal");

  var _useState = (0,react.useState)(false),
      playing = _useState[0],
      setPlaying = _useState[1];

  var play = function play() {
    return setPlaying(true);
  };

  var stop = function stop() {
    return setPlaying(false);
  };

  return /*#__PURE__*/(0,react_dom.createPortal)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledModal, {
      size: "xlarge",
      ref: ref,
      placement: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* Body */.uT, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VideoPlayer/* default */.ZP, {
          url: url,
          playing: autoplay ? true : playing,
          onPause: stop,
          onPlay: play,
          config: {
            wistia: {
              options: {
                playerColor: theme.palette.twilio.gray[100],
                playButton: false,
                smallPlayButton: false
              }
            }
          },
          children: [!playing && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoPlayer/* BigPlayButton */.sT, {
            ariaLabel: "Play Button",
            onClick: play
          }), !playing && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoPlayer/* Cover */.Y9, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Picture, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
                type: "image/webp",
                srcSet: cover
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, {
                width: "800",
                height: "455",
                src: cover,
                alt: "Illustration: Cover",
                loading: "lazy"
              })]
            })
          }, "cover")]
        })
      })
    })
  }), modalsRoot);
});

var StyledModal = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Modal/* default */.ZP,  true ? {
  target: "ez9cyw32"
} : 0)( true ? {
  name: "ddxhyk",
  styles: "max-width:800px"
} : 0);

var Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "ez9cyw31"
} : 0)( true ? {
  name: "9th5i",
  styles: "margin:0 auto"
} : 0);

var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "ez9cyw30"
} : 0)("background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[100];
}, ";display:block;width:100%;height:100%;object-fit:cover;" + ( true ? "" : 0));

/* harmony default export */ var VideoModal_VideoModal = (VideoModal);
// EXTERNAL MODULE: ./src/views/GoodData/components/Hero/assets/Hero@2x.png
var Hero_2x = __webpack_require__(16560);
var Hero_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_2x);
// EXTERNAL MODULE: ./src/views/GoodData/components/Hero/assets/Hero.webp
var assets_Hero = __webpack_require__(803);
var Hero_default = /*#__PURE__*/__webpack_require__.n(assets_Hero);
// EXTERNAL MODULE: ./src/views/GoodData/components/Hero/assets/Hero@2x.webp
var assets_Hero_2x = __webpack_require__(35407);
var assets_Hero_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_2x);
// EXTERNAL MODULE: ./src/views/GoodData/components/Hero/assets/HeroBackground.png
var HeroBackground = __webpack_require__(99843);
var HeroBackground_default = /*#__PURE__*/__webpack_require__.n(HeroBackground);
// EXTERNAL MODULE: ./src/views/GoodData/components/Hero/assets/HeroBackground.webp
var assets_HeroBackground = __webpack_require__(23977);
var assets_HeroBackground_default = /*#__PURE__*/__webpack_require__.n(assets_HeroBackground);
// EXTERNAL MODULE: ./src/views/GoodData/components/Hero/assets/HeroVideoCoverImage.png
var HeroVideoCoverImage = __webpack_require__(8798);
var HeroVideoCoverImage_default = /*#__PURE__*/__webpack_require__.n(HeroVideoCoverImage);
;// CONCATENATED MODULE: ./src/views/GoodData/components/Hero/assets/hero-good-data.json.data
/* harmony default export */ var hero_good_data_json = ("/_next/static/data/hero-good-data.json-8c7f416ad4f91df3d68b72cb5637a167.json");
;// CONCATENATED MODULE: ./src/views/GoodData/components/Hero/Hero.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Hero_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



















var copy = {
  heading: "Everything is better with good data",
  description: "Twilio Segment brings together clean, consented, real-time customer data for every team, so you can deliver personalized customer experiences that grow revenue.",
  button: "Watch now"
};
var video = {
  cover: (HeroVideoCoverImage_default()),
  url: "https://youtu.be/NKjHQMrwPnc"
};

var Hero = function Hero() {
  var modalRef = (0,react.useRef)(null);
  var modalOpenState = (0,react.useState)(false);

  var _modalOpenState = (0,slicedToArray/* default */.Z)(modalOpenState, 1),
      opened = _modalOpenState[0];

  var _useModal = (0,useModal/* default */.Z)(modalRef, modalOpenState),
      getControlOpenProps = _useModal.getControlOpenProps;

  var _useState = (0,react.useState)(),
      animationData = _useState[0],
      setAnimationData = _useState[1];

  (0,react.useEffect)(function () {
    setAnimationData(fetch(hero_good_data_json));
  }, []);

  var _useLottie = (0,useLottie/* default */.Z)({
    options: {
      autoplay: true,
      animationData: animationData,
      loop: true
    }
  }),
      _useLottie2 = (0,slicedToArray/* default */.Z)(_useLottie, 2),
      animation = _useLottie2[0],
      containerRef = _useLottie2[1];

  var isInView = (0,useInView/* default */.Z)(containerRef);
  (0,react.useEffect)(function () {
    if (isInView) {
      animation === null || animation === void 0 ? void 0 : animation.play();
    }
  }, [animation, isInView]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHero, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "homeH2",
          tag: "h1",
          children: copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "homePExtraLarge",
          tag: "p",
          children: copy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ButtonText/* default */.Z, _objectSpread(_objectSpread({
          size: "medium",
          tag: "a"
        }, getControlOpenProps()), {}, {
          children: [copy.button, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronRightIcon */.XC, {})]
        }))]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
        children: animationData ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Animation, {
          ref: containerRef
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
            type: "image/webp",
            srcSet: "".concat((Hero_default()), ", ").concat((assets_Hero_2x_default()), " 2x")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Image */.Ee, {
            width: "1281",
            height: "1080",
            src: (Hero_2x_default()),
            alt: "Illustration: Personalization is better with good data",
            loading: "eager"
          })]
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Background, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
          type: "image/webp",
          srcSet: "".concat((assets_HeroBackground_default()))
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Image */.Ee, {
          src: (HeroBackground_default()),
          alt: "Hero Background Image",
          loading: "eager",
          fill: true
        })]
      })
    }), opened ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoModal_VideoModal, {
      ref: modalRef,
      url: video.url,
      cover: video.cover,
      autoplay: true
    }) : null]
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "esezfr03"
} : 0)("position:relative;background:transparent;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("md");
}, "{background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[100];
}, ";}" + ( true ? "" : 0));

var Background = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "esezfr02"
} : 0)("background-color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.twilio.gray[100];
}, ";position:absolute;top:0;width:100%;height:100%;z-index:-1;" + ( true ? "" : 0));

var StyledHero = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "esezfr01"
} : 0)(recipes_Hero/* Wrapper */.im, "{gap:50px;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.down("md");
}, "{gap:0px;}", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("sm");
}, "{padding-bottom:20px;}", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.up("md");
}, "{padding-bottom:40px;}", function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.up("xl");
}, "{padding-bottom:0;padding-top:0;}}" + ( true ? "" : 0));

var Animation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "esezfr00"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/Company.ts + 264 modules
var Company = __webpack_require__(24984);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var Card = __webpack_require__(74881);
;// CONCATENATED MODULE: ./src/views/GoodData/components/Companies/VideoCard.tsx


function VideoCard_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var VideoCard = function VideoCard(_ref) {
  var logo = _ref.logo,
      image = _ref.image,
      onClick = _ref.onClick;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCard, {
    onClick: onClick,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoCard_StyledImage, {
      variant: "fill",
      src: image,
      alt: ""
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledBody, {
      children: logo
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledPlayButton, {})]
  });
};

var StyledCard = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Card/* default */.ZP,  true ? {
  target: "ey3w2pj3"
} : 0)( true ? {
  name: "1te1vur",
  styles: "position:relative;cursor:pointer"
} : 0);

var VideoCard_StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Card/* Image */.Ee,  true ? {
  target: "ey3w2pj2"
} : 0)("height:240px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{height:260px;}" + ( true ? "" : 0));

var StyledBody = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Card/* Body */.uT,  true ? {
  target: "ey3w2pj1"
} : 0)( true ? {
  name: "1c3q8v3",
  styles: "padding:18px;justify-content:start;svg,img{display:inline-block;height:22px;width:auto;}"
} : 0);

var StyledPlayButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ey3w2pj0"
} : 0)("position:absolute;top:50%;left:50%;transform:translate(-50%, -70%);width:80px;height:80px;background:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.neutrals.white[100];
}, ";border-radius:50%;transition:300ms ease;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{width:88px;height:88px;}::before{content:'';position:absolute;top:50%;left:50%;width:0;height:0;transform:translate(-40%, -50%);border-top:14px solid transparent;border-bottom:14px solid transparent;border-left:26px solid ", function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.twilio.blue[60];
}, ";}:hover{background:", function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette.twilio.blue[60];
}, ";::before{border-left:26px solid ", function (_ref7) {
  var theme = _ref7.theme;
  return theme.palette.neutrals.white[100];
}, ";}}" + ( true ? "" : 0));

/* harmony default export */ var Companies_VideoCard = (VideoCard);
// EXTERNAL MODULE: ./src/views/GoodData/components/Companies/assets/BoxImage.jpg
var BoxImage = __webpack_require__(57151);
var BoxImage_default = /*#__PURE__*/__webpack_require__.n(BoxImage);
// EXTERNAL MODULE: ./src/views/GoodData/components/Companies/assets/SanofiImage.jpg
var SanofiImage = __webpack_require__(64713);
var SanofiImage_default = /*#__PURE__*/__webpack_require__.n(SanofiImage);
// EXTERNAL MODULE: ./src/views/GoodData/components/Companies/assets/RoostifyImage.jpg
var RoostifyImage = __webpack_require__(79343);
var RoostifyImage_default = /*#__PURE__*/__webpack_require__.n(RoostifyImage);
// EXTERNAL MODULE: ./src/views/GoodData/components/Companies/assets/RoostifyLogo.png
var RoostifyLogo = __webpack_require__(27512);
var RoostifyLogo_default = /*#__PURE__*/__webpack_require__.n(RoostifyLogo);
// EXTERNAL MODULE: ./src/views/GoodData/components/Companies/assets/BoxVideoCoverImage.png
var BoxVideoCoverImage = __webpack_require__(39401);
var BoxVideoCoverImage_default = /*#__PURE__*/__webpack_require__.n(BoxVideoCoverImage);
// EXTERNAL MODULE: ./src/views/GoodData/components/Companies/assets/SanofiVideoCoverImage.png
var SanofiVideoCoverImage = __webpack_require__(16668);
var SanofiVideoCoverImage_default = /*#__PURE__*/__webpack_require__.n(SanofiVideoCoverImage);
// EXTERNAL MODULE: ./src/views/GoodData/components/Companies/assets/RoostifyVideoCoverImage.png
var RoostifyVideoCoverImage = __webpack_require__(78056);
var RoostifyVideoCoverImage_default = /*#__PURE__*/__webpack_require__.n(RoostifyVideoCoverImage);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ./src/views/GoodData/components/Companies/Companies.tsx




function Companies_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Companies_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Companies_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Companies_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Companies_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




















var Companies_copy = {
  heading: "More than 25,000 companies are powered by good data with Segment ",
  description: "Empower your teams to make real-time decisions, accelerate growth, and deliver world-class customer experiences."
};
var cards = [{
  id: "box",
  href: "#box",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* BoxLogo */.R52, {}),
  image: (BoxImage_default()),
  videoUrl: "https://youtu.be/t8BFUnn66Wo",
  videoCover: (BoxVideoCoverImage_default())
}, {
  id: "sanofi",
  href: "#sanofi",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* SanofiLogo */.usZ, {}),
  image: (SanofiImage_default()),
  videoUrl: "https://youtu.be/tRlWAMX_2Pc",
  videoCover: (SanofiVideoCoverImage_default())
}, {
  id: "roostify",
  href: "#roostify",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
    src: (RoostifyLogo_default()),
    width: 876,
    height: 125,
    alt: ""
  }),
  image: (RoostifyImage_default()),
  videoUrl: "https://youtu.be/Cb6AgkFn0dU",
  videoCover: (RoostifyVideoCoverImage_default())
}];

var Companies = function Companies() {
  var modalRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(null),
      activeVideo = _useState[0],
      setActiveVideo = _useState[1];

  var modalOpenState = (0,react.useState)(false);

  var _modalOpenState = (0,slicedToArray/* default */.Z)(modalOpenState, 1),
      opened = _modalOpenState[0];

  var _useModal = (0,useModal/* default */.Z)(modalRef, modalOpenState),
      getControlOpenProps = _useModal.getControlOpenProps;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Companies_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSection, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCopy, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h2",
          tag: "h2",
          children: Companies_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pExtraLarge",
          tag: "p",
          children: Companies_copy.description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledContent, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          overrides: {
            md: 3
          },
          columns: 1,
          children: cards.map(function (card, index) {
            return (0,emotion_react_browser_esm/* createElement */.az)(Companies_VideoCard, Companies_objectSpread(Companies_objectSpread({}, getControlOpenProps({
              onClick: function onClick() {
                setActiveVideo(index);
              }
            })), {}, {
              key: card.id,
              logo: card.logo,
              image: card.image
            }));
          })
        })
      })]
    }), opened && activeVideo !== null ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoModal_VideoModal, {
      ref: modalRef,
      url: cards[activeVideo].videoUrl,
      cover: cards[activeVideo].videoCover
    }) : null]
  });
};

var Companies_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e186wyh43"
} : 0)( true ? "" : 0);

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e186wyh42"
} : 0)(Section/* Wrapper */.im, "{gap:40px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{gap:80px;}}" + ( true ? "" : 0));

var StyledCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e186wyh41"
} : 0)( true ? {
  name: "zvsj7h",
  styles: "max-width:612px;text-align:center"
} : 0);

var StyledContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e186wyh40"
} : 0)( true ? {
  name: "3hppma",
  styles: "max-width:1120px"
} : 0);

/* harmony default export */ var Companies_Companies = (Companies);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ./src/views/GoodData/components/EmbraceGoodData/assets/EmbraceGoodData.webp
var assets_EmbraceGoodData = __webpack_require__(7549);
var EmbraceGoodData_default = /*#__PURE__*/__webpack_require__.n(assets_EmbraceGoodData);
// EXTERNAL MODULE: ./src/views/GoodData/components/EmbraceGoodData/assets/EmbraceGoodData@2x.webp
var EmbraceGoodData_2x = __webpack_require__(50018);
var EmbraceGoodData_2x_default = /*#__PURE__*/__webpack_require__.n(EmbraceGoodData_2x);
// EXTERNAL MODULE: ./src/views/GoodData/components/EmbraceGoodData/assets/EmbraceGoodData@2x.png
var assets_EmbraceGoodData_2x = __webpack_require__(71871);
var assets_EmbraceGoodData_2x_default = /*#__PURE__*/__webpack_require__.n(assets_EmbraceGoodData_2x);
;// CONCATENATED MODULE: ./src/views/GoodData/components/EmbraceGoodData/EmbraceGoodData.tsx


function EmbraceGoodData_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var EmbraceGoodData_copy = {
  heading: "Embrace the power of good data",
  description: ["Data is the only resource capable of the speed and scale required to deliver relevant, real-time experiences to every customer.", "Achieving good data within an organization has become increasingly complex. Learn how to avoid the common pitfalls of bad data, and empower your business with trusted, real-time insights."],
  button: {
    text: "Download now",
    href: "https://segment.com/learn/download/why-bad-data-happens-to-good-companies/?utm_source=good-data-hub&utm_medium=referral&utm_campaign=all_ic_2024-05-16-cnt-good%20data-why-bad-data-happens-to-good-companies%20_20240516&utm_content=ebook"
  }
};

var EmbraceGoodData = function EmbraceGoodData() {
  var _copy$description;

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmbraceGoodData_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EmbraceGoodData_StyledSection, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
        alignSelf: "center",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h2",
          tag: "h2",
          children: EmbraceGoodData_copy.heading
        }), (_copy$description = EmbraceGoodData_copy.description) === null || _copy$description === void 0 ? void 0 : _copy$description.map(function (description, index) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "homePLarge",
            tag: "p",
            children: description
          }, index);
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
            variant: "primary",
            size: "medium",
            href: (0,getAbsoluteUrl/* default */.Z)("".concat(EmbraceGoodData_copy.button.href), pageConfig),
            iconEnd: Common/* ChevronRightIcon */.XC,
            children: EmbraceGoodData_copy.button.text
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
              type: "image/webp",
              srcSet: "".concat((EmbraceGoodData_default()), ", ").concat((EmbraceGoodData_2x_default()), " 2x")
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
              width: "640",
              height: "470",
              src: (assets_EmbraceGoodData_2x_default()),
              alt: "Illustration: Embrace the power of good data",
              loading: "lazy"
            })]
          })
        })
      })]
    })
  });
};

var EmbraceGoodData_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "emez0f52"
} : 0)( true ? "" : 0);

var EmbraceGoodData_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "emez0f51"
} : 0)(Section/* Wrapper */.im, "{gap:80px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("md");
}, "{gap:40px;}}" + ( true ? "" : 0));

var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "emez0f50"
} : 0)( true ? {
  name: "iqoq9n",
  styles: "margin-top:20px"
} : 0);

/* harmony default export */ var EmbraceGoodData_EmbraceGoodData = (EmbraceGoodData);
// EXTERNAL MODULE: ../../libs/matcha/components/Badge/index.ts + 2 modules
var Badge = __webpack_require__(16154);
// EXTERNAL MODULE: ./src/views/GoodData/components/GetStarted/assets/GetStartedBackground.png
var GetStartedBackground = __webpack_require__(39091);
var GetStartedBackground_default = /*#__PURE__*/__webpack_require__.n(GetStartedBackground);
// EXTERNAL MODULE: ./src/views/GoodData/components/GetStarted/assets/GetStartedBackground.webp
var assets_GetStartedBackground = __webpack_require__(97855);
var assets_GetStartedBackground_default = /*#__PURE__*/__webpack_require__.n(assets_GetStartedBackground);
;// CONCATENATED MODULE: ./src/views/GoodData/components/GetStarted/GetStarted.tsx


function GetStarted_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }















var GetStarted_copy = {
  heading: "Get started with good data",
  subheading: "Achieving data maturity unlocks revenue for your business. Learn how with advice from our experts and industry analysts."
};
var data = [{
  url: "https://webinars.segment.com/segment/maximizing-customer-experience-with-a-strong-data-foundation?utm_source=good-data-hub&utm_medium=referral&utm_campaign=all_ic_2024-03-20-wbnr-maximizing-cx-with-a-data-foundation_20240522&utm_content=webinar",
  badge: "Webinar",
  heading: "Maximize customer experience with a strong data foundation",
  subheading: "Hear from 451 Research on why companies that invest in their data deliver better outcomes and more revenue.",
  buttonText: "Watch now"
}, {
  url: "https://segment.com/learn/download/idc-marketshare-2022/?utm_source=good-data-hub&utm_medium=referral&utm_campaign=all_ic_2022-10-11-cnt-idc-marketshare-report_20240522&utm_content=report",
  badge: "Analyst Report",
  heading: "IDC CDP MarketShare Report",
  subheading: "Dive into why IDC has ranked Twilio the #1 CDP in worldwide market shares for four consecutive years (2022, 2021, 2020, 2019).",
  buttonText: "Download"
}, {
  url: "https://webinars.segment.com/segment/how-to-win-cx-with-data-activation-forrester?utm_source=good-data-hub&utm_medium=referral&utm_campaign=all_ic_2024-04-16-wbnr-forrester-win-with-cx_20240522&utm_content=webinar",
  badge: "Webinar",
  heading: "How to win CX with differentiated data",
  subheading: "Learn from Forrester on how to integrate your warehouse and tech stack to differentiate your real-time CX strategies.",
  buttonText: "Watch now"
}, {
  url: "https://webinars.segment.com/segment/twilio-segment-summer-school-customer-data-maturity-101-session-1-building-a-rock-solid-data-foundation-for-your-business?utm_source=good-data-hub&utm_medium=referral&utm_campaign=all_ic_2023-07-12-wbnr-cnt-cdm-intro-and-foundations_20240522&utm_content=webinar",
  badge: "Webinar",
  heading: "Building a rock-solid data foundation for your business",
  subheading: "Learn how a strong customer data foundation can set your engagement strategy up for success.",
  buttonText: "Watch now"
}, {
  url: "https://webinars.segment.com/segment/from-insight-to-implementation-advancing-beyond-the-basics?utm_source=good-data-hub&utm_medium=referral&utm_campaign=all_ic_2023-07-26-wbnr-cdm-advancing%20_20240522&utm_content=webinar",
  badge: "Webinar",
  heading: "From insights to implementation: advancing beyond the basics",
  subheading: "Start to add more complexity to your data strategy by activating your audiences and driving funnel conversion.",
  buttonText: "Watch now"
}, {
  url: "https://webinars.segment.com/segment/adapting-your-data-strategy-on-the-road-to-mastery?utm_source=good-data-hub&utm_medium=referral&utm_campaign=all_ic_2023-08-22-wbnr-cdm-adapting-your-data-strategy%20_20240522&utm_content=webinar",
  badge: "Webinar",
  heading: "Adapting your data strategy on the road to mastery",
  subheading: "Become the leader in your category by exceeding customer expectations and staying ahead of the competition.",
  buttonText: "Watch now"
}];

var GetStarted = function GetStarted() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GetStarted_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GetStarted_StyledSection, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h2",
            tag: "h2",
            children: GetStarted_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            children: GetStarted_copy.subheading
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnsWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
            columns: 1,
            overrides: {
              md: 3
            },
            children: data.map(function (card, index) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.ZP, {
                href: (0,getAbsoluteUrl/* default */.Z)("".concat(card.url), pageConfig),
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Body */.uT, {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Accessories */.v8, {
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* AccessoriesRow */.OW, {
                      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
                        variant: "outlined",
                        children: card.badge
                      })
                    })
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Copy */.CK, {
                    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Headline */.s0, {
                      tag: "h3",
                      children: card.heading
                    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Description */.dk, {
                      children: card.subheading
                    })]
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Action */.aU, {
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
                      iconEnd: Common/* ChevronRightIcon */.XC,
                      children: card.buttonText
                    })
                  })]
                })
              }, index);
            })
          })
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GetStarted_Background, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
          type: "image/webp",
          srcSet: "".concat((assets_GetStartedBackground_default()))
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
          src: (GetStartedBackground_default()),
          alt: "Hero Background Image",
          loading: "eager",
          fill: true
        })]
      })
    })]
  });
};

var GetStarted_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xu0spp3"
} : 0)("position:relative;background:transparent;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("md");
}, "{background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.mint[10];
}, ";}" + ( true ? "" : 0));

var GetStarted_Background = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xu0spp2"
} : 0)("background:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.twilio.mint[10];
}, ";position:absolute;top:0;width:100%;height:100%;z-index:-1;max-width:100vw;" + ( true ? "" : 0));

var GetStarted_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1xu0spp1"
} : 0)(Section/* Wrapper */.im, "{gap:0;}" + ( true ? "" : 0));

var ColumnsWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xu0spp0"
} : 0)( true ? {
  name: "1huv1ah",
  styles: "margin-top:60px"
} : 0);

/* harmony default export */ var GetStarted_GetStarted = (GetStarted);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/tracking/scripts/index.ts + 2 modules
var scripts = __webpack_require__(17397);
;// CONCATENATED MODULE: ./src/views/GoodData/components/CtaSection/CtaSection.tsx


function CtaSection_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var CtaSection_copy = {
  heading: "See Twilio Segment in action",
  description: "Learn how you can start connecting your data with Twilio Segment. Explore our plans to find the one that\u2019s right for your team."
};
var buttons = [{
  text: "Take the interactive tour",
  href: "/product-tour?utm_source=good-data-hub&utm_medium=referral&utm_campaign=all_ic_2024-05-22-DG-good-data-campaign_20240522&utm_content=product-tour ",
  variant: "filled"
}, {
  text: "Pricing",
  href: "/pricing?utm_source=good-data-hub&utm_medium=referral&utm_campaign=all_ic_2024-05-22-DG-good-data-campaign_20240522&utm_content=pricing-page",
  variant: "outlined"
}];

var CtaSection = function CtaSection() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCopyTextBase, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextHeading, {
          children: CtaSection_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          children: CtaSection_copy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonsWrapper, {
          children: buttons.map(function (button) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
              size: "large",
              color: "primary",
              variant: button.variant,
              href: (0,getAbsoluteUrl/* default */.Z)(button.href, pageConfig),
              onClick: function onClick() {
                return (0,scripts/* trackButtonClick */.kO)({
                  buttonText: button.text,
                  targetUrl: button.href
                });
              },
              children: button.text
            }, button.text);
          })
        })]
      })
    })
  });
};

var StyledCopyTextHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "e15dwdjw2"
} : 0)( true ? {
  name: "1fgdcyd",
  styles: "margin-bottom:24px"
} : 0);

var StyledCopyTextBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "e15dwdjw1"
} : 0)( true ? {
  name: "j5085c",
  styles: "max-width:612px;margin:0 auto"
} : 0);

var ButtonsWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e15dwdjw0"
} : 0)("display:flex;gap:24px;justify-content:center;margin-top:20px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("sm");
}, "{flex-direction:column;}" + ( true ? "" : 0));

/* harmony default export */ var CtaSection_CtaSection = (CtaSection);
// EXTERNAL MODULE: ./src/views/GoodData/assets/OgGoodData.png
var OgGoodData = __webpack_require__(1815);
var OgGoodData_default = /*#__PURE__*/__webpack_require__.n(OgGoodData);
;// CONCATENATED MODULE: ./src/views/GoodData/GoodData.tsx
















var GoodDataView = function GoodDataView() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Everything is Better with Good Data | Twilio Segment",
      pageDescription: "Segment helps every team access good data. Data that's real-time, clean, and accurate. The result? Relevant customer experiences that drive real revenue.",
      pageOG: (OgGoodData_default()),
      themeColor: theme.palette.brand.darkAcai[700],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
        appearance: "twilioDark",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {})
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Companies_Companies, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DividerSection/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmbraceGoodData_EmbraceGoodData, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GetStarted_GetStarted, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaSection_CtaSection, {})]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e1sjiptq0"
} : 0)( true ? "" : 0);

/* harmony default export */ var GoodData_GoodData = (GoodDataView);
;// CONCATENATED MODULE: ./src/pages/gooddata/index.tsx



var GoodData = function GoodData() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GoodData_GoodData, {});
};

/* harmony default export */ var gooddata = (GoodData);

/***/ }),

/***/ 12795:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;

var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var _loadable = _interop_require_default(__webpack_require__(84949));

function dynamic(dynamicOptions, options) {
  var loadableFn = _loadable["default"];
  var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
    // A loading component is not required, so we default it
    loading: function loading(_ref) {
      var error = _ref.error,
          isLoading = _ref.isLoading,
          pastDelay = _ref.pastDelay;
      if (!pastDelay) return null;

      if (false) {}

      return null;
    }
  }; // Support for direct import(), eg: dynamic(import('../hello-world'))
  // Note that this is only kept for the edge case where someone is passing in a promise as first argument
  // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
  // To make sure we don't execute the import without rendering first

  if (dynamicOptions instanceof Promise) {
    loadableOptions.loader = function () {
      return dynamicOptions;
    }; // Support for having import as a function, eg: dynamic(() => import('../hello-world'))

  } else if (typeof dynamicOptions === 'function') {
    loadableOptions.loader = dynamicOptions; // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
  } else if (typeof dynamicOptions === 'object') {
    loadableOptions = _extends({}, loadableOptions, dynamicOptions);
  } // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})


  loadableOptions = _extends({}, loadableOptions, options); // Error if Fizz rendering is not enabled and `suspense` option is set to true

  if (false) {}

  if (loadableOptions.suspense) {
    if (false) {}

    delete loadableOptions.ssr;
    delete loadableOptions.loading;
  } // coming from build/babel/plugins/react-loadable-plugin.js


  if (loadableOptions.loadableGenerated) {
    loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
    delete loadableOptions.loadableGenerated;
  } // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
  // skip `ssr` for suspense mode and opt-in React.lazy directly


  if (typeof loadableOptions.ssr === 'boolean' && !loadableOptions.suspense) {
    if (!loadableOptions.ssr) {
      delete loadableOptions.ssr;
      return noSSR(loadableFn, loadableOptions);
    }

    delete loadableOptions.ssr;
  }

  return loadableFn(loadableOptions);
}

var isServerSide = false;

function noSSR(LoadableInitializer, loadableOptions) {
  // Removing webpack and modules means react-loadable won't try preloading
  delete loadableOptions.webpack;
  delete loadableOptions.modules; // This check is necessary to prevent react-loadable from initializing on the server

  if (!isServerSide) {
    return LoadableInitializer(loadableOptions);
  }

  var Loading = loadableOptions.loading; // This will only be rendered on the server side

  return function () {
    return /*#__PURE__*/_react["default"].createElement(Loading, {
      error: null,
      isLoading: true,
      pastDelay: false,
      timedOut: false
    });
  };
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 49749:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LoadableContext = void 0;

var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var LoadableContext = _react["default"].createContext(null);

exports.LoadableContext = LoadableContext;

if (false) {}

/***/ }),

/***/ 84949:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__(22624);

var _createClass = __webpack_require__(85458);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var _loadableContext = __webpack_require__(49749);

var _ref =  true ? __webpack_require__(2784) : 0,
    useSyncExternalStore = _ref.useSyncExternalStore;

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;

function load(loader) {
  var promise = loader();
  var state = {
    loading: true,
    loaded: null,
    error: null
  };
  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  })["catch"](function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });
  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj["default"] : obj;
}

function createLoadableComponent(loadFn, options) {
  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    webpack: null,
    modules: null,
    suspense: false
  }, options);

  if (opts.suspense) {
    opts.lazy = _react["default"].lazy(opts.loader);
  }
  /** @type LoadableSubscription */


  var subscription = null;

  function init() {
    if (!subscription) {
      var sub = new LoadableSubscription(loadFn, opts);
      subscription = {
        getCurrentValue: sub.getCurrentValue.bind(sub),
        subscribe: sub.subscribe.bind(sub),
        retry: sub.retry.bind(sub),
        promise: sub.promise.bind(sub)
      };
    }

    return subscription.promise();
  } // Server only


  if (false) {} // Client only


  if (!initialized && true) {
    // require.resolveWeak check is needed for environments that don't have it available like Jest
    var moduleIds = opts.webpack && "function" === 'function' ? opts.webpack() : opts.modules;

    if (moduleIds) {
      READY_INITIALIZERS.push(function (ids) {
        var _iterator = _createForOfIteratorHelper(moduleIds),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var moduleId = _step.value;

            if (ids.indexOf(moduleId) !== -1) {
              return init();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
  }

  function useLoadableModule() {
    init();

    var context = _react["default"].useContext(_loadableContext.LoadableContext);

    if (context && Array.isArray(opts.modules)) {
      opts.modules.forEach(function (moduleName) {
        context(moduleName);
      });
    }
  }

  function LoadableImpl(props, ref) {
    useLoadableModule();
    var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);

    _react["default"].useImperativeHandle(ref, function () {
      return {
        retry: subscription.retry
      };
    }, []);

    return _react["default"].useMemo(function () {
      if (state.loading || state.error) {
        return _react["default"].createElement(opts.loading, {
          isLoading: state.loading,
          pastDelay: state.pastDelay,
          timedOut: state.timedOut,
          error: state.error,
          retry: subscription.retry
        });
      } else if (state.loaded) {
        return _react["default"].createElement(resolve(state.loaded), props);
      } else {
        return null;
      }
    }, [props, state]);
  }

  function LazyImpl(props, ref) {
    useLoadableModule();
    return _react["default"].createElement(opts.lazy, _extends({}, props, {
      ref: ref
    }));
  }

  var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;

  LoadableComponent.preload = function () {
    return init();
  };

  LoadableComponent.displayName = 'LoadableComponent';
  return _react["default"].forwardRef(LoadableComponent);
}

var LoadableSubscription = /*#__PURE__*/function () {
  function LoadableSubscription(loadFn, opts) {
    _classCallCheck(this, LoadableSubscription);

    this._loadFn = loadFn;
    this._opts = opts;
    this._callbacks = new Set();
    this._delay = null;
    this._timeout = null;
    this.retry();
  }

  _createClass(LoadableSubscription, [{
    key: "promise",
    value: function promise() {
      return this._res.promise;
    }
  }, {
    key: "retry",
    value: function retry() {
      var _this = this;

      this._clearTimeouts();

      this._res = this._loadFn(this._opts.loader);
      this._state = {
        pastDelay: false,
        timedOut: false
      };
      var res = this._res,
          opts = this._opts;

      if (res.loading) {
        if (typeof opts.delay === 'number') {
          if (opts.delay === 0) {
            this._state.pastDelay = true;
          } else {
            this._delay = setTimeout(function () {
              _this._update({
                pastDelay: true
              });
            }, opts.delay);
          }
        }

        if (typeof opts.timeout === 'number') {
          this._timeout = setTimeout(function () {
            _this._update({
              timedOut: true
            });
          }, opts.timeout);
        }
      }

      this._res.promise.then(function () {
        _this._update({});

        _this._clearTimeouts();
      })["catch"](function (_err) {
        _this._update({});

        _this._clearTimeouts();
      });

      this._update({});
    }
  }, {
    key: "_update",
    value: function _update(partial) {
      this._state = _extends({}, this._state, {
        error: this._res.error,
        loaded: this._res.loaded,
        loading: this._res.loading
      }, partial);

      this._callbacks.forEach(function (callback) {
        return callback();
      });
    }
  }, {
    key: "_clearTimeouts",
    value: function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    }
  }, {
    key: "getCurrentValue",
    value: function getCurrentValue() {
      return this._state;
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this2 = this;

      this._callbacks.add(callback);

      return function () {
        _this2._callbacks["delete"](callback);
      };
    }
  }]);

  return LoadableSubscription;
}();

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function flushInitializers(initializers, ids) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init(ids));
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers, ids);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolveInitializers, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
  });
};

Loadable.preloadReady = function () {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new Promise(function (resolvePreload) {
    var res = function res() {
      initialized = true;
      return resolvePreload();
    }; // We always will resolve, errors should be handled within loading UIs.


    flushInitializers(READY_INITIALIZERS, ids).then(res, res);
  });
};

if (true) {
  window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}

var _default = Loadable;
exports["default"] = _default;

/***/ }),

/***/ 95290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82269);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81333);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27866);



var _excluded = ["onClick"],
    _excluded2 = ["onClick"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



var DEFAULT_OPTIONS = {
  closeOnOverlayClick: true
};
var DEFAULT_EVENTS = ["mousedown", "touchstart"];

var useModal = function useModal(menuRef, _ref, options) {
  var _ref2 = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, 2),
      setOpened = _ref2[1];

  var settings = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
  }, [options]);

  var getControlOpenProps = function getControlOpenProps() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _onClick = _ref3.onClick,
        rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref3, _excluded);

    return _objectSpread({
      onClick: function onClick(event) {
        setOpened(true);
        _onClick === null || _onClick === void 0 ? void 0 : _onClick(event);
      }
    }, rest);
  };

  var getControlCloseProps = function getControlCloseProps() {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _onClick2 = _ref4.onClick,
        rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref4, _excluded2);

    return _objectSpread({
      'aria-label': "Close the modal",
      onClick: function onClick(event) {
        setOpened(false);
        _onClick2 === null || _onClick2 === void 0 ? void 0 : _onClick2(event);
      }
    }, rest);
  };

  (0,react_use__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(menuRef, function () {
    if (settings.closeOnOverlayClick) {
      setOpened(false);
    }
  }, settings.closeOnOverlayClick ? DEFAULT_EVENTS : []);
  return {
    getControlOpenProps: getControlOpenProps,
    getControlCloseProps: getControlCloseProps
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useModal);

/***/ }),

/***/ 52876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DividerSection_DividerSection; }
});

// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/DividerSection/DividerSection.views.tsx


var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ec103ko0"
} : 0)(Section/* Wrapper */.im, "{padding-top:0;padding-bottom:0;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/DividerSection/DividerSection.tsx





var DividerSection = function DividerSection() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {})
    })
  });
};

/* harmony default export */ var DividerSection_DividerSection = (DividerSection);

/***/ }),

/***/ 85507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _DividerSection__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _DividerSection__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52876);


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 73849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var lottie_web__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12039);
/* harmony import */ var lottie_web__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lottie_web__WEBPACK_IMPORTED_MODULE_2__);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



/**
 * A hook that provides an animation instance and a ref to the container element.
 * @param options The options to configure the animation.
 * @returns The animation instance and a ref to the container element.
 */

var useLottie = function useLottie(_ref) {
  var options = _ref.options;
  var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      animationInstance = _useState[0],
      setAnimationInstance = _useState[1];

  var initializedRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (!containerRef || !options.animationData || initializedRef.current) {
      return;
    }

    initializedRef.current = true;
    options.animationData.then(function (response) {
      return typeof response.json === "function" ? response.json() : response;
    }).then(function (data) {
      setAnimationInstance(lottie_web__WEBPACK_IMPORTED_MODULE_2___default().loadAnimation(_objectSpread(_objectSpread({
        container: containerRef.current
      }, options), {}, {
        animationData: data
      })));
    });
    return function () {
      return animationInstance === null || animationInstance === void 0 ? void 0 : animationInstance.destroy();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerRef, options.animationData]);
  return [animationInstance, containerRef];
};

/* harmony default export */ __webpack_exports__["Z"] = (useLottie);

/***/ }),

/***/ 25530:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gooddata",
      function () {
        return __webpack_require__(3414);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(12795)


/***/ }),

/***/ 1815:
/***/ (function(module) {

module.exports = "/_next/static/images/OgGoodData-ad03720670d39ad737b38b78a06738b9.png";

/***/ }),

/***/ 57151:
/***/ (function(module) {

module.exports = "/_next/static/images/BoxImage-ce63740f7d4e4e6b3c0094b8a7ca45be.jpg";

/***/ }),

/***/ 39401:
/***/ (function(module) {

module.exports = "/_next/static/images/BoxVideoCoverImage-0087f18e168c89f03b7a1031eb989ba2.png";

/***/ }),

/***/ 79343:
/***/ (function(module) {

module.exports = "/_next/static/images/RoostifyImage-6a8da2b26d59b77e3c0546affa2ace05.jpg";

/***/ }),

/***/ 27512:
/***/ (function(module) {

module.exports = "/_next/static/images/RoostifyLogo-5e870229b12da990fd237b47d3b5becb.png";

/***/ }),

/***/ 78056:
/***/ (function(module) {

module.exports = "/_next/static/images/RoostifyVideoCoverImage-ce813cbd6a5209d14dfb0391906082f8.png";

/***/ }),

/***/ 64713:
/***/ (function(module) {

module.exports = "/_next/static/images/SanofiImage-5e5bb3cfc9317fad93b6c17e8c3a0fd3.jpg";

/***/ }),

/***/ 16668:
/***/ (function(module) {

module.exports = "/_next/static/images/SanofiVideoCoverImage-f30bc89c694d0f0c7f3bdc75dece8cda.png";

/***/ }),

/***/ 71871:
/***/ (function(module) {

module.exports = "/_next/static/images/EmbraceGoodData@2x-12daf605eaa87dd1e082170b19b1c1c3.png";

/***/ }),

/***/ 39091:
/***/ (function(module) {

module.exports = "/_next/static/images/GetStartedBackground-83cf861f7ad744e82e9b245c93cddeca.png";

/***/ }),

/***/ 16560:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-d96addc05d091891a1c470db63a1728d.png";

/***/ }),

/***/ 99843:
/***/ (function(module) {

module.exports = "/_next/static/images/HeroBackground-e6983e04889987bdb04d3b301731e60a.png";

/***/ }),

/***/ 8798:
/***/ (function(module) {

module.exports = "/_next/static/images/HeroVideoCoverImage-83845a9bacc5262f09a9a9981f884595.png";

/***/ }),

/***/ 7549:
/***/ (function(module) {

module.exports = "/_next/static/images/EmbraceGoodData-5338b3d893ceeee77960eefbff3c01c9.webp";

/***/ }),

/***/ 50018:
/***/ (function(module) {

module.exports = "/_next/static/images/EmbraceGoodData@2x-5249813c38ae58733d2e78ae7b351c6f.webp";

/***/ }),

/***/ 97855:
/***/ (function(module) {

module.exports = "/_next/static/images/GetStartedBackground-d86eb59b39020804b0a6de7361e91e51.webp";

/***/ }),

/***/ 803:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-a3a7269c5f51a91e2be396b5b4852c1f.webp";

/***/ }),

/***/ 35407:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-cc6d00d2b919854254d05a3c0814239e.webp";

/***/ }),

/***/ 23977:
/***/ (function(module) {

module.exports = "/_next/static/images/HeroBackground-8721467cebd387df8271ec9ef07d221a.webp";

/***/ }),

/***/ 45302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ rng; }
/* harmony export */ });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/***/ }),

/***/ 20708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ unsafeStringify; }
/* harmony export */ });

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (stringify)));

/***/ }),

/***/ 20982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_browser_v4; }
});

;// CONCATENATED MODULE: ../../node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ var esm_browser_native = ({
  randomUUID
});
// EXTERNAL MODULE: ../../node_modules/uuid/dist/esm-browser/rng.js
var rng = __webpack_require__(45302);
// EXTERNAL MODULE: ../../node_modules/uuid/dist/esm-browser/stringify.js
var stringify = __webpack_require__(20708);
;// CONCATENATED MODULE: ../../node_modules/uuid/dist/esm-browser/v4.js




function v4(options, buf, offset) {
  if (esm_browser_native.randomUUID && !buf && !options) {
    return esm_browser_native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng/* default */.Z)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return (0,stringify/* unsafeStringify */.S)(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7642,3287,9097,6577,3607,1382,4136,2073,8392,7096,2429,1367,7303,3996,8187,4984,4881,9774,2888,179], function() { return __webpack_exec__(25530); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);